// extracted by mini-css-extract-plugin
module.exports = {"mediaWrapper":"_3sHmh","imageWrapper":"_1FqoY","heading":"_3X8oo","subHeading":"_3r3Qy"};